module.exports = __webpack_public_path__ + "img/logo09.757a104.jpg";